import { Box, Flex, Text } from '@mantine/core';
import IntegrationLogo from '@/pages/Integrations/components/IntegrationLogo.tsx';
import useCreateNangoIntegration from '@/hooks/useCreateNangoIntegration.ts';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { IntegrationProvider } from '@/types/integrations.ts';
import { useState } from 'react';
import SharePointConnectModal from '@/components/SharePointConnectModal.tsx';
import { isSharePointProvider } from '@/utils/providerKinds.ts';

type props = {
  provider: IntegrationProvider;
};

const UnconnectedIntegration = ({ provider }: props) => {
  const { createIntegration, createIntegrationFromButton, creatingIntegration } =
    useCreateNangoIntegration();
  const [sharePointConnectOpened, setSharePointConnectOpened] = useState(false);

  return (
    <Box px="sm" py={'xs'} style={{ border: '1px solid #e0e0e0', borderRadius: 4 }}>
      <Flex justify="space-between" align="center">
        <Flex align="center" gap="xs">
          <IntegrationLogo name={provider.name} />

          <Text size="sm">{provider.display_name}</Text>
        </Flex>
        <StyledButton
          variant={'outline'}
          size={'sm'}
          onClick={() => {
            if (isSharePointProvider(provider)) {
              setSharePointConnectOpened(true);
              return;
            }
            void createIntegrationFromButton(provider);
          }}
          loading={creatingIntegration}
          style={{ boxShadow: 'none', border: '1px solid var(--velos-brand-blue)' }}
          c="var(--velos-brand-blue)"
        >
          Connect
        </StyledButton>
      </Flex>
      {isSharePointProvider(provider) && (
        <SharePointConnectModal
          opened={sharePointConnectOpened}
          onClose={() => setSharePointConnectOpened(false)}
          confirmLoading={creatingIntegration}
          onConfirm={async (sharepointTenantId) => {
            await createIntegration(provider, sharepointTenantId);
            setSharePointConnectOpened(false);
          }}
        />
      )}
    </Box>
  );
};

export default UnconnectedIntegration;
